package reading

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun ReadingModeSelectionScreen(
    onModeSelected: (Boolean) -> Unit, // true = Examen, false = Tareas
    onBack: () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            minHeight(100.vh)
            backgroundColor(Color("#f0f2f5"))
            padding(20.px)
        }
    }) {
        // Кнопка НАЗАД (вверху слева)
        Div({
            style {
                width(100.percent)
                maxWidth(800.px)
                marginBottom(20.px)
            }
        }) {
            Button({
                style {
                    backgroundColor(Color.white)
                    border(0.px)
                    fontSize(1.5.cssRem)
                    cursor("pointer")
                    padding(5.px, 15.px)
                    borderRadius(20.px)
                    property("box-shadow", "0 2px 5px rgba(0,0,0,0.1)")
                }
                onClick { onBack() }
            }) { Text("⬅️ Volver") }
        }

        H2({ style { color(Color("#2c3e50")); marginBottom(40.px) } }) {
            Text("Elige el modo de práctica")
        }

        // Контейнер с двумя карточками
        Div({
            style {
                display(DisplayStyle.Flex)
                property("gap", "30px")
                property("flex-wrap", "wrap")
                justifyContent(JustifyContent.Center)
                width(100.percent)
            }
        }) {
            // ВАРИАНТ 1: ЭКЗАМЕН
            SelectionCard(
                title = "Simulacro de Examen",
                icon = "⏱️",
                description = "Las 5 tareas seguidas. 60 minutos. Sin pausas.",
                color = "#e74c3c", // Красный (строгий)
                onClick = { onModeSelected(true) } // true = Exam
            )

            // ВАРИАНТ 2: ПО ЗАДАЧАМ
            SelectionCard(
                title = "Práctica por Tareas",
                icon = "📚",
                description = "Elige qué tarea practicar. Sin límite de tiempo.",
                color = "#2ecc71", // Зеленый (спокойный)
                onClick = { onModeSelected(false) } // false = Practice
            )
        }
    }
}

@Composable
fun SelectionCard(
    title: String,
    icon: String,
    description: String,
    color: String,
    onClick: () -> Unit
) {
    Div({
        onClick { onClick() }
        style {
            backgroundColor(Color.white)
            width(300.px)
            padding(40.px)
            borderRadius(16.px)
            property("box-shadow", "0 10px 25px rgba(0,0,0,0.05)")
            cursor("pointer")
            property("transition", "transform 0.2s")
            textAlign("center")
          //  borderTop(5.px, LineStyle.Solid, Color(color)) // Цветная шапка
        }
        attr("onmouseover", "this.style.transform='translateY(-5px)'")
        attr("onmouseout", "this.style.transform='translateY(0)'")
    }) {
        Div({ style { fontSize(3.5.cssRem); marginBottom(20.px) } }) { Text(icon) }
        H3({ style { margin(0.px); marginBottom(15.px); color(Color("#2c3e50")) } }) { Text(title) }
        P({ style { color(Color("#7f8c8d")); lineHeight("1.5em") } }) { Text(description) }

        Button({
            style {
                marginTop(25.px)
                padding(10.px, 25.px)
                backgroundColor(Color(color))
                color(Color.white)
                border(0.px)
                borderRadius(20.px)
                cursor("pointer")
                fontWeight("bold")
            }
        }) { Text("Seleccionar") }
    }
}